// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chart1_wrapper__2Uooq"};